import React, { useRef, useEffect, useMemo } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'
import { clone } from 'three/examples/jsm/utils/SkeletonUtils.js'

export function PinkTreeModel(props) {
  const group = useRef()

  const { scene, materials, animations } = useGLTF('/playground/pink_tree.glb')

  // Clone the scene and memoize it per instance
  const clonedScene = useMemo(() => clone(scene), [scene])
  const { actions } = useAnimations(animations, group)

  useEffect(() => {
    actions['windAction.001']?.reset().play()
  }, [actions])

  return <primitive ref={group} object={clonedScene} {...props} />
}

useGLTF.preload('/playground/pink_tree.glb')
